import { useState, useRef, useCallback } from "react";

export function useClipboard() {
  const [copiedKey, setCopiedKey] = useState<string | null>(null);
  const timerRef = useRef<ReturnType<typeof setTimeout> | null>(null);

  const copy = useCallback(async (key: string, value: string): Promise<boolean> => {
    let ok = false;
    try {
      if (navigator.clipboard) {
        await navigator.clipboard.writeText(value);
        ok = true;
      } else {
        // Legacy fallback
        const ta = document.createElement("textarea");
        ta.value = value;
        ta.style.position = "fixed";
        ta.style.opacity = "0";
        document.body.appendChild(ta);
        ta.select();
        ok = document.execCommand("copy");
        document.body.removeChild(ta);
      }
    } catch {
      ok = false;
    }
    if (ok) {
      setCopiedKey(key);
      if (timerRef.current) clearTimeout(timerRef.current);
      timerRef.current = setTimeout(() => setCopiedKey(null), 1400);
    }
    return ok;
  }, []);

  return { copiedKey, copy };
}
